import axios from "axios";
import store from "@/store/store";
import router from "@/router";

export const initInterceptors = () => {
    let refreshTokenPromise = null;
    let lastRefreshOrganization = null;
    let lastInsufficientPermission = null;

    axios.defaults.baseURL = process.env.VUE_APP_API_URL;

    axios.interceptors.response.use(r => r, (error) => {
        if (error.config.url.includes('token') &&  !error.config.url.includes('apple') && !error.config.url.includes('third-party')) {
            if (store.getters.isAuthenticated) {
                store.commit('logout');
                router.push({name: 'login'});
            }

            return Promise.reject(error);
        }

        if (error.response && error.response.status === 401) {
            if (!refreshTokenPromise) {
                refreshTokenPromise = store.dispatch('refreshToken').then(() => {
                    refreshTokenPromise = null;
                    return store.getters.getToken;
                });
            }

            return refreshTokenPromise.then(token => {
                error.config.headers['Authorization'] = 'Bearer ' + token;
                if (!token) {
                    return Promise.reject(error);
                }
                return axios.request(error.config);
            });
        }

        if (error.response && error.response.status >= 500) {
            store.dispatch('addNotification', {
                type: 'error',
                message: 'serverError',
                translate: true
            });
        } else if (error.response.data && error.response.data.ErrorMessages) {
            if(error.response.data.ErrorMessages.includes('InsufficientPermissions')) {
                if (!lastRefreshOrganization  || new Date().getTime() - lastRefreshOrganization  > 20*1000) {
                    store.dispatch('updateOrganizations');
                    lastRefreshOrganization = new Date().getTime();
                }
                if(!lastInsufficientPermission ||  new Date().getTime() - lastInsufficientPermission  > 1*1000 ) {
                    store.dispatch('addNotification', {
                        type: 'error',
                        message: error.response.data.ErrorMessages,
                        translate: true,
                    });
                    lastInsufficientPermission = new Date().getTime();
                }
            } else {
                store.dispatch('addNotification', {
                    type: 'error',
                    message: error.response.data.ErrorMessages,
                    translate: true,
                });
            }
        }

        return Promise.reject(error);
    });

    axios.interceptors.request.use(config => {
        const token = store.getters.getToken;
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        if (!config.headers['Content-Type']) {
            config.headers['Content-Type'] = 'application/json';
        }

        return config;
    });

};
